/** Etiqueta legible (i18n) del rol de un usuario dentro de una empresa. */
import type { UserRole } from './auth/types';
import { t, type MessageKey } from './i18n';

const ROLE_KEYS: Record<string, MessageKey> = {
  SUPER_ADMIN: 'role.SUPER_ADMIN',
  COMPANY_ADMIN: 'role.COMPANY_ADMIN',
  MEMBER: 'role.MEMBER',
};

export function roleLabel(role: UserRole | undefined | null): string {
  if (!role) return '';
  const key = ROLE_KEYS[role];
  return key ? t(key) : role;
}
